import React from "react";
import PitaRouter from "../router/pita.js";

const PitaLayout = () => {
  return (
    <div
      className="kt-content kt-grid__item kt-grid__item--fluid"
      id="kt_content"
    >
      <PitaRouter />
    </div>
  );
};

export default PitaLayout;
